import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { GlobalLoaderComponent } from '@shared/components/global-loader/global-loader.component';
import { GlobalLoader } from '@shared/components/global-loader/global-loader.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalLoaderService {
  lastXhrNumber = 0;
  loaderComponent!: ComponentRef<GlobalLoaderComponent>;

  componentRef?: ComponentRef<GlobalLoaderComponent>;

  public loader: {
    component: ComponentRef<GlobalLoaderComponent>;
    element: HTMLElement;
  }[] = [];

  public commonLoader: BehaviorSubject<GlobalLoader> =
    new BehaviorSubject<GlobalLoader>(new GlobalLoader());

  // TODO ComponentFactoryResolver-t kiváltani
  constructor(
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef
  ) {
    this.commonLoader.subscribe((loader: GlobalLoader) => {
      setTimeout(() => {
        if (this.lastXhrNumber === 0 && this.commonLoader.value.xhrNumber > 0) {
          this.showLoader();
        }
        if (this.lastXhrNumber > 0 && this.commonLoader.value.xhrNumber === 0) {
          this.hideLoader();
        }
        this.lastXhrNumber = this.commonLoader.value.xhrNumber;
      }, loader.timeout);
    });
  }

  public incrementXhrNumber(timeout?: number): void {
    const loaderModel = new GlobalLoader(
      this.commonLoader.value.xhrNumber + 1,
      timeout
    );
    this.commonLoader.next(loaderModel);
  }

  public decrementXhrNumber(timeout?: number): void {
    const loaderModel = new GlobalLoader(
      Math.max(0, this.commonLoader.value.xhrNumber - 1),
      timeout
    );
    this.commonLoader.next(loaderModel);
  }

  public showLoader(): void {
    const loaderComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        GlobalLoaderComponent
      );
    this.loaderComponent = loaderComponentFactory.create(this.injector);
    this.create(this.loaderComponent);
  }

  private create(loaderComponent: ComponentRef<GlobalLoaderComponent>): void {
    this.appRef.attachView(loaderComponent.hostView);
    const domElem = (loaderComponent.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  public hideLoader(): void {
    this.appRef.detachView(this.loaderComponent.hostView);
    this.loaderComponent.destroy();
  }
}
